module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_56.c4201311.jpg";